<template>
<div id="home">
   <transition name="main">
    <div class="split js-home static static-home" v-if="!loading">
        <div class="split-item split-left">
            <div class="split-left-inner split-inner">
                <div class="inner-box" v-bind:class="{pointerevent:isTopBoke}">
                    <div class="top-contents" v-bind:class="{bokeboke:isTopBoke}">

                        <div class="top-navi-wrap">
                            <div class="center">
                                <div class="top-navi-tit">大琉球語辞典について</div>
                            </div>
                            <ul class="top-navi">
                                <li class="active" v-for="(item,index) in topmenu1" :key="index">
                                  <a href="#" v-on:click="openmenu(item)">
                                     {{item.title}} 
                                  </a>
                              </li>
                            </ul>
                            <br class="clear">


                            <div class="center">
                                <div class="top-navi-tit">辞典について</div>
                            </div>
                            <ul class="top-navi">
                              <li class="active" v-for="(item,index) in topmenu2" :key="index">
                                  <a href="#" v-on:click="openmenu(item)">
                                     {{item.title}} 
                                  </a>
                              </li>
                            </ul>
                        </div>
                        <div class="top-image">
                            <img src="../assets/img/map.png" class="img-blur" alt="地図">
                        </div>
                    </div>
                    <div v-show="isSubMenu">
                    <sub-menu></sub-menu>
                    </div>
                </div>
            </div>
        </div>
        <div class="split-item split-right">
            <div class="split-right-inner split-inner">
                <div class="inner-box">
                    <div class="static-wrap">
                        
                        <content-view></content-view>

                    </div>
                </div>
            </div>
        </div>
    </div>
  </transition>
  <transition name="fade">
    <div v-bind:class="['loader-wrap-title', loading?'':'invis-loader']" v-show="loading">
        <div class="loader">
            <div class="loading-text">
                <p class="text1 img-blur">伊波普猷が構想し、仲宗根政善があたためた</p>
                <p class="title text2 img-blur">大琉球語辞典</p>
            </div>
        </div>
    </div>
  </transition>
    
</div>
<!-- home END -->





</template>


<style>
/* はじめ */
.main-enter {
  /* 最初は表示して欲しくないので 0 */
  opacity: 0;
}
/* transition している間 */
.main-enter-active {
  transition: opacity 1s
}
/* おわり */
.main-enter-to {
  /* 終わったら表示して欲しいので 1 */
  opacity: 1;
}
.invis-loader{
  visibility:hidden;
}
.pointerevent{
    pointer-events: none;
}
.bokeboke{
        opacity: 0.6;/*半透明カラーの透明度*/
        filter: blur(2px);/*ぼかし度*/
}
</style>
<script>
import contentView from '@/components/ContentView.vue'
import subMenu from '@/components/SubMenu.vue'
import {API_URL} from '@/services/config'
import {CONTENTS_SRV} from '@/services/config'
export default {
  name: 'home',
  components: {
   // HelloWorld
   contentView,
   subMenu
  },
  data(){
    return{
    loading: true,
    topmenu1:[
      {title:'琉球語概説'},
      {title:'プロジェクト概要'}],
    topmenu2:[
      {title:'今帰仁'},
      {title:'首里那覇'},
      {title:'奄美'},
      {title:'宮古下里'},
      {title:'与論'},
      {title:'伊是名'}
    ],
    menuall:[]
    }
  },
  computed:{
      isTopBoke(){
          return this.$store.getters.isTopBoke;
      },
      isSubMenu(){
          return this.$store.getters.isSubMenu;
      }

  },
  mounted: function(){
    console.log("mounted")
        this.init();
        if(history.state == 'entry'){
          if(!this.$store.getters.isSearchBox && this.$store.getters.content=='' ){
                  this.$store.dispatch('upIsSearchBox',true);
          }
        }
        history.replaceState('entry', null);
  },
  methods:{
      init:function(){
        var self = this;

        if(this.$cookie.get('isLoading')=='1'){
            self.loading = false;
        }
        this.$cookie.set('isLoading', '1', );
        self.$axios.get(`${API_URL}/search/getmenus`)
          .then((res)=>{
               self.menuall = res.data;
               self.topmenu1 = self.menuall.filter(x => x.parent_id === '1');
               self.topmenu2 = self.menuall.filter(x => x.parent_id === '2');
          });
        
//aaaaa  フェードアウトを追加してみる（９・３）
        setTimeout( self.closeOpenning,8000);
      },
      closeOpenning:function(){
        this.loading=false;
        //$('body').bootstrapMaterialDesign(); 
      },
      openmenu:function(item){
          var self = this;
          var subMenu = self.menuall.filter(x => x.parent_id === item.menu_id);
          if(subMenu[0]){
            this.$store.dispatch('upSubMenuData',subMenu.slice());
            if(!item.imagefile)
                this.$store.dispatch('upSubMenuImage','');
            else
                this.$store.dispatch('upSubMenuImage',`${CONTENTS_SRV}/content/menu/${item.imagefile}`);
            this.$store.dispatch('upIsSubMenu',true);
            this.$store.dispatch('upIsTopBoke',true);
          }else{
              this.contentdisp(item);
          }
      },
      closemenu:function(){

          this.$store.dispatch('upIsSubMenu',false);
          this.$store.dispatch('upIsTopBoke',false);
      },
      contentdisp(item){
           var self=this;
          var params = new URLSearchParams();
          params.append('menu_id',item.menu_id);
          self.$axios.post(`${API_URL}/search/getcontent`, params)
          .then((res)=>{
                if(res.data.contentValue === null)
                {
                  this.$store.dispatch('upIsSearchBox',true);
                  return ;
                }
              this.$store.dispatch('upContent',(res.data.contentValue === null) ? '' : res.data.contentValue);
              this.$store.dispatch('upIsSearchBox',false);
          });
      }
  }
}



</script>
